import supabase from '../../utils/supabase-client';
const cache = new Map();
const pending = new Map();
export function getCachedAuthor(id) {
    return cache.get(id);
}
export function pruneAuthorCache(keepUserIds) {
    for (const id of cache.keys()) {
        if (!keepUserIds.has(id))
            cache.delete(id);
    }
}
export function clearAuthorCache() {
    cache.clear();
    pending.clear();
}
/** Seeds in-process author cache (unit tests). */
export function seedAuthorCacheForTests(entries) {
    for (const row of entries)
        cache.set(row.id, row);
}
async function fetchMissing(ids) {
    const missing = ids.filter((id) => !cache.has(id));
    if (missing.length === 0)
        return;
    const dedup = Array.from(new Set(missing));
    const toFetch = [];
    const waits = [];
    for (const id of dedup) {
        const inflight = pending.get(id);
        if (inflight)
            waits.push(inflight);
        else
            toFetch.push(id);
    }
    if (toFetch.length > 0) {
        const p = (async () => {
            const { data, error } = await supabase
                .from('users')
                .select('id, first_name, last_name, role')
                .in('id', toFetch);
            if (!error && data) {
                for (const row of data)
                    cache.set(row.id, row);
            }
            for (const id of toFetch)
                pending.delete(id);
        })();
        for (const id of toFetch)
            pending.set(id, p);
        waits.push(p);
    }
    await Promise.all(waits);
}
/** Fetch any user ids not yet cached. Safe to call from hooks or reducers. */
export async function ensureAuthorsCached(ids) {
    const deduped = Array.from(new Set(ids.filter(Boolean)));
    if (deduped.length === 0)
        return;
    await fetchMissing(deduped);
}
